<template>
	<div class="list-container">
		<div class="floor-header">
			<div class="title">{{ $t('user_list.title') }}</div>
			<!--
				TODO: Lås ner vilka som får lägga till / ta bort användare
			-->
			<div
				class="add"
				:class="{ mobile: isMobile }"
				v-if="$isAllowedTo('buildings_administer_connected_users')"
			>
				<v-select
					class="panel-select user"
					:options="comUsers"
					v-model="selectedUser"
					:placeholder="$t('user_list.select_user_placeholder')"
					:allowEmpty="false"
					:internalSearch="true"
					:showLabels="false"
					:custom-label="getName"
					trackBy="id"
				>
					<span slot="noResult">{{ $t('user_list.no_results') }}</span>
					<span
						slot="caret"
						slot-scope="{ toggle }"
						class="caret"
						@mousedown.prevent.stop="toggle()"
					><i class="fas fa-caret-down caret-inner"></i
					></span>
				</v-select>
				<button class="button is-info connect-left" @click="onAdd">
					<span class="icon is-white"><i class="fas fa-plus"/></span
					><span>{{ $t('user_list.add') }}</span>
				</button>
			</div>
		</div>
		<div class="panel-list-header">
			<div class="panel-header-item">{{ $t('user_list.name') }}</div>
			<div class="panel-filler" />
		</div>
		<div
			class="panel-list"
			v-for="(user, index) in buildingUsers"
			:key="user.id"
		>
			<div class="panel-list-item">
				{{ `${user.firstName} ${user.lastName}` }}
			</div>
			<div class="list-button" @click.stop="onRemove(index)" v-if="$isAllowedTo('buildings_administer_connected_users')">
				<i class="fas fa-minus"></i>
			</div>
		</div>
		<div class="panel-list" v-if="buildingUsers.length == 0">
			<p class="panel-list-item">{{ $t('user_list.no_users') }}</p>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	props: {
		buildingUsers: Array,
		building: {
			type: Object,
			required: true
		}
	},

	data: () => ({
		users: [],
		selectedUser: {},
		searchParams: {
			search: '',
			orderBy: 'LastName',
			pageSize: 0,
			currentPage: 1
		}
	}),

	computed: {
		...mapGetters('user', ['getActiveCustomer', 'getActiveCompany']),
		...mapGetters('appStore', ['isMobile']),

		comUsers() {
			let users = this.users;
			let selectedUsers = this.buildingUsers;

			if (selectedUsers) {
				let newUsers = users.filter(this.comparer(selectedUsers));

				return newUsers;
			}

			return users;
		}
	},

	created() {
		this.fetchUsers();
	},

	methods: {
		onRemove(index) {
			this.$emit('remove', index);
		},

		onAdd() {
			if (this.selectedUser.id) this.$emit('add', this.selectedUser);

			this.selectedUser = {};
		},

		getName(user) {
			return user.id
				? `${user.firstName} ${user.lastName}`
				: this.$t('user_list.select_user_placeholder');
		},


		comparer(otherArray) {
			return current => {
				return (
					otherArray.filter(other => {
						return other.id === current.id;
					}).length === 0
				);
			};
		},

		searchUsers(value) {
			this.searchParams.search = value;
			this.fetchUsers();
		},

		async fetchUsers() {
			/*
			TODO: Behöver läggas till så man kan hämta använda på andra companies/customer för kors-koppling
			*/
			try {
				this.users = await this.$services.user.getUsersIncludingExternal({
					customerId: this.$isAllowedTo('buildings_link_any_user') ? null : this.getActiveCustomer?.id,
					companyId: this.getActiveCompany.id,
					...this.searchParams
				});
			} catch (error) {
				console.log(error);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.floor-header {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  .add {
    display: flex;
    margin-bottom: 0rem;
    height: 40px;
    &.mobile {
      margin-left: auto;
    }
  }
  .button {
    border-radius: 2px;
    &.connect-left {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>

<style lang="scss">
@import "@/assets/colors.scss";

.multiselect.panel-select.user {
  max-width: 200px;
  height: 40px;
  .caret {
    background-color: #fcfcfc;
  }
  .multiselect__tags {
    background-color: white;

    .multiselect__single,
    .multiselect__input {
      background-color: white;
    }
  }
  .multiselect__content {
    background: white;
  }
}
</style>
